import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface BillingTypeViewProps {
    mode: ControlMode;
    model: any;
    onChanged: (item: any) => void;
    required?: boolean;
    label?: string;
}

export class BillingTypeView extends React.Component<BillingTypeViewProps, any> {
    optionsType = [
        { value: 'PerNight', label: 'Per Night' },
        { value: 'PerNightPerPerson', label: 'Per Night per Person' },
        { value: 'PerDay', label: 'Per Day' },
        { value: 'PerDayPerPerson', label: 'Per Day per Person' },
        { value: 'PerHour', label: 'Per Hour' },
        { value: 'PerHourPerPerson', label: 'Per Hour per Person' },
        { value: 'PerProduct', label: 'Per Product' },
        { value: 'PerPerson', label: 'Per Person' }
    ];

    constructor(props) {
        super(props);
    }

    render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Price type:';
        }

        return <DropdownView
            disabled={this.props.mode == 'display'}
            label={label}
            model={this.props.model}
            required={this.props.required}
            onChanged={this.props.onChanged}
            options={this.optionsType}
        />
    }
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/billing-type.view.tsx